import { Link } from "react-router-dom";

/**
 * Mandatory consent checkbox used on every submission form.
 * Pass `value` (boolean) and `onChange` (function). Optional `testid`.
 */
export default function ConsentCheckbox({ value, onChange, testid = "consent-checkbox", showDisclaimer = true }) {
  return (
    <div className="mt-5 space-y-2">
      <label className="flex items-start gap-3 text-xs text-slate-600 leading-relaxed cursor-pointer">
        <input
          type="checkbox"
          required
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          data-testid={testid}
          className="mt-0.5 h-4 w-4 accent-[#29324A] shrink-0"
        />
        <span>
          I consent to Shamima Yasmin Anwar collecting and storing my information for assessment and support purposes in accordance with the{" "}
          <Link to="/privacy-policy" target="_blank" className="text-[#29324A] underline hover:text-[#C43A89]">Privacy Policy</Link>.
        </span>
      </label>
      {showDisclaimer && (
        <p className="text-[11px] text-slate-400 italic pl-7 leading-relaxed">
          This tool provides general guidance only and does not constitute migration advice or guarantee visa outcomes.
        </p>
      )}
    </div>
  );
}
